/* eslint-disable camelcase */
import { path } from 'ramda';
import { Application } from '../../../types/applications';
import { formatToReadableDate, formatStringIfDate } from '../../../utils/dates';
const applicationInformationOrder = [
    'name',
    'age',
    'movingWith',
    'movingWithAmount',
    'movingWithDescription',
    'pets',
    'petType',
    'readyForMoveDate',
    'lifeSituation',
    'depositPaymentMethod',
    'livelihoodDescription',
    'hasFinSSN',
    'guarantorPossible',
    'gender',
    'language',
    'notes'
];
const applicationInformationOrderAdmin = [
    'applicationId',
    'code',
    'statusUpdatedAt',
    ...applicationInformationOrder
];
export interface StatusGroups {
    created: Application[];
    accepted: Application[];
    showingReserved: Application[];
    tenant: Application[];
}
const sortApplicationsByStatus = (applications: Application[]) => applications.reduce((statusGroups: StatusGroups, application: Application) => {
    const status = path(['status'], application);
    (statusGroups as any)[`${status}`].push(application);
    return statusGroups;
}, {
    created: [],
    accepted: [],
    showingReserved: [],
    tenant: []
});
export interface ApplicationAmounts {
    created: number;
    accepted: number;
    noAvailableTimes: number;
    showingReserved: number;
}
const getCreatedAmount = (applications: Application[] | undefined) => {
    let createdAmount = 0;
    applications
        ? applications.forEach((application: Application) => path(['status'], application) === 'created' ? createdAmount++ : null)
        : (createdAmount = 0);
    return createdAmount;
};
const getApplicationsAmounts = (applications: Application[]): ApplicationAmounts => applications.reduce((amounts: ApplicationAmounts, application: Application) => {
    const status = path(['status'], application);
    (amounts as any)[`${status}`]++;
    return amounts;
}, {
    created: 0,
    accepted: 0,
    noAvailableTimes: 0,
    showingReserved: 0
});
const getGeneralTranslationIfExists = (value: any) => value ? `general.${value}` : undefined;
const getUniqueTranslationIfExists = (value: any, propName: string) => value ? `application.${propName}.${value}` : undefined;
const getApplicationDataWithTranslations = (application: Application, isAdmin = false) => {
    const { applicationId, code, statusUpdatedAt, data: { age, language, lifeSituation, movingWith, depositPaymentMethod, pets, readyForMoveDate }, phoneShown } = application;
    return {
        ...application.data,
        applicationId: isAdmin ? applicationId : undefined,
        code: isAdmin ? code : undefined,
        statusUpdatedAt: statusUpdatedAt
            ? formatToReadableDate(statusUpdatedAt, 'HH.MM dd.mm.yyyy')
            : undefined,
        age: getUniqueTranslationIfExists(age, 'age'),
        lifeSituation: getUniqueTranslationIfExists(lifeSituation, 'lifeSituation'),
        movingWith: getUniqueTranslationIfExists(movingWith, 'movingWith'),
        depositPaymentMethod: getUniqueTranslationIfExists(depositPaymentMethod, 'depositPaymentMethod'),
        language: getUniqueTranslationIfExists(language, 'language'),
        pets: getGeneralTranslationIfExists(pets),
        readyForMoveDate: formatStringIfDate(readyForMoveDate),
        phoneShown: phoneShown ? true : false,
    };
};
const getApplicationStatus = (applicationData: Application) => path(['status'], applicationData) ? applicationData.status : false;
export { applicationInformationOrder, applicationInformationOrderAdmin, getApplicationDataWithTranslations, getApplicationStatus, sortApplicationsByStatus, getCreatedAmount, getApplicationsAmounts };
